import { Component, OnInit, Input, Output, EventEmitter, trigger, state, style, transition, animate } from '@angular/core';

@Component({
  selector: 'cm-menu-mobile',

  template: `
    <nav class="menu-mobile" >
        <div><img src="./assets/images/logo-carte-mariale.png" /></div>
        <div class="bouton-menu" (click)="ouvrirFermerMenu()"><i class="fa fa-bars" aria-hidden="true"></i></div>
    </nav>

    <div class="menu-deroulant"
         *ngIf="etatMenuDeroulant === 'visible'">
         
         <div class="menu-item" (click)="ouvrirFermerMenu(); afficherEcranRecherche.emit()">Rechercher</div>
         <div class="menu-item" (click)="ouvrirFermerMenu(); afficherEcranFavoris.emit()">Favoris</div>
         <div class="menu-item" (click)="ouvrirFermerMenu(); afficherEcranInfoLegende.emit()">Légende / informations</div>
         <div class="menu-item" (click)="ouvrirFermerMenu(); afficherEcranAPropos.emit()">À propos</div>
         <div class="menu-item" (click)="ouvrirFermerMenu(); afficherEcranMentionLegale.emit()">Mention légales</div>
         <div class="menu-item" (click)="ouvrirFermerMenu()"><a href="http://www.mariedenazareth.com" target="_blank"> Marie de Nazareth </a></div>

    </div>
  `,

  styles: [`
    .menu-mobile {
        height: 0px;
    }
    .menu-mobile img {
        height: 40px;
        position: relative;
        top: -5px;
        left: 0;
    }
    .bouton-menu {
        cursor: pointer;
    }
    .menu-item {
        font-size: 20px;
        padding: 15px 30px 15px 15px;
        border-bottom: solid 1px black;
        cursor: pointer;
        font-weight: 700;
        text-align: right;
        background-color: white;
        z-index: 5;
    }
    .menu-item a {
        text-decoration: none;
        color: black;
    }

    @media (max-width: 800px), (max-height: 700px) { 
        .menu-mobile {
            height: 45px;
            width: 100vw;
            background-color: #006296;
            color: #FFA300;
            display: flex;
            justify-content: space-between;
            padding-left: 10px;
            padding-right: 10px;
            font-size: 30px;
            align-items: center;
        }
        .menu-deroulant {
            background-color: rgba(0,53,82,0.5);
            width: 100vw;
            height: calc(100vh - 45px);
        }
    }
  `]
})
export class MenuMobileComponent implements OnInit {

  etatMenuDeroulant: string;

  @Output() afficherEcranRecherche: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranInfoLegende: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranFavoris: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranAPropos: EventEmitter<any> = new EventEmitter();
  @Output() afficherEcranMentionLegale: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {
      this.etatMenuDeroulant = 'invisible';
  }

  ouvrirFermerMenu() {
      this.etatMenuDeroulant = this.etatMenuDeroulant === 'invisible' ? 'visible' : 'invisible';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/menu-mobile.component.ts